module.exports = __webpack_public_path__ + "img/Dantam Hair 24.744236d5.jpg";